import React, { PureComponent } from 'react';
import SVGSpriteUrl from './assets/icon-sprite.svg';
import styled, { createGlobalStyle } from 'styled-components';
import Tippy from '@tippy.js/react';
import 'tippy.js/dist/tippy.css';

const InfoTooltipButton = styled.button`
  background-color: transparent;
  padding: 0;
  border: 0;
  cursor: pointer;
  vertical-align: middle;
  margin-left: 5px;
`;

const IconSVG = styled.svg`
  pointer-events: none;
  max-width: 100%;
  max-height: 100%;
  fill: ${props => props.iconColor};
  stroke: ${props => props.iconColor};
`;

const IconSVGWrapper = styled.div`
  display: inline-block;
  width: ${props => props.iconWidth};
  height: ${props => props.iconHeight};
`;

const BENTippyTheme = createGlobalStyle`
  .tippy-tooltip.ben-theme {
    font-size: 16px !important;
    line-height: 24px !important;
    padding: 20px !important;
    font-family: latoregular !important;
    border: 2px solid rgb(66, 188, 218) !important;
    border-radius: 5px !important;
    background: #fff !important;
    box-shadow: 0px 1px 70px 0px rgba(0, 0, 0, 0.2) !important;
    color: #262f33 !important;
    max-width: 500px !important;
    text-align: initial;
  }
`;

class InfoTooltip extends PureComponent {
  render() {
    return (
      <React.Fragment>
        <BENTippyTheme />
        <Tippy
          content={this.props.text}
          performance={true}
          trigger={`click`}
          placement={`right-end`}
          animateFill={false}
          zIndex={0}
          theme={`ben`}
          size={`large`}
        >
          <InfoTooltipButton type="button">
            <IconSVGWrapper
              iconWidth={this.props.iconWidth}
              iconHeight={this.props.iconHeight}
            >
              <IconSVG iconColor={this.props.iconColor}>
                <use href={`${SVGSpriteUrl}#icon-info`} />
              </IconSVG>
            </IconSVGWrapper>
          </InfoTooltipButton>
        </Tippy>
      </React.Fragment>
    );
  }
}

export default InfoTooltip;
